import {
  ApiLpErrorResolutionPolicy, IApiLp, IApiLpDetails, IApiLpErrorResolution, IApiLpUpdate, IApiLpConnectionSettings,
} from '@cbridge-packages/api';
import { LpTranslator } from '@cbridge-packages/lp';
import { ScheduleTranslator } from '@cbridge-packages/schedule';
import { IClientLp, IClientLpErrorResolution, IClientLpForm, IConnectionSettings } from './clientLp.interface';

export namespace ClientLpTranslator {
  function fromApiErrorResolution(errorResolution?: IApiLpErrorResolution): IClientLpErrorResolution {
    return {
      policy: errorResolution?.policy ?? ApiLpErrorResolutionPolicy.Manual,
      resetSeqNumFlagSupported: errorResolution?.resetSeqNumFlagSupported ?? false,
    };
  }

  export function fromApi(lp: IApiLp): IClientLp {
    return {
      lpId: lp.id,
      name: lp.name,
      region: lp.region,
      adapter: lp.adapter,
      enabled: lp.enabled,
      errorResolution: fromApiErrorResolution(lp.errorResolution),
      schedule: lp.schedule && {
        scheduleId: lp.schedule?.id,
        scheduleName: lp.schedule?.name,
        timezone: undefined,
        pricingIntervals: undefined,
        tradingIntervals: undefined,
      },
      trading: LpTranslator.fromApiLpConnectionState(lp.trading),
      pricing: LpTranslator.fromApiLpConnectionState(lp.pricing),
    };
  }

  export function fromApiDetails(lp: IApiLpDetails): IClientLp {
    const schedule = lp.schedule ? ScheduleTranslator.fromApiFullView(lp.schedule) : undefined;
    return {
      lpId: lp.id,
      name: lp.name,
      region: lp.region,
      adapter: lp.adapter,
      enabled: lp.enabled,
      errorResolution: fromApiErrorResolution(lp.errorResolution),
      schedule,
      trading: LpTranslator.fromApiConnection(lp.trading),
      pricing: LpTranslator.fromApiConnection(lp.pricing),
    };
  }

  export function toApiConnectionSettings(connection: Partial<IConnectionSettings>): IApiLpConnectionSettings {
    return {
      login: connection.login,
      password: connection.password,
      adapterSettings: (connection.adapterSettings ?? [])
        .filter(({ key, value }) => key?.trim() && value?.trim())
        .map(({ key, value }) => ({ key, value })),
    };
  }

  export function toApi(lp: IClientLpForm): IApiLpUpdate {
    return {
      lpId: lp.lpId,
      name: lp.name,
      enabled: lp.enabled,
      trading: ClientLpTranslator.toApiConnectionSettings(lp.trading),
      pricing: ClientLpTranslator.toApiConnectionSettings(lp.pricing),
      scheduleId: lp.scheduleId ?? null,
    };
  }
}
